import styles, { layout } from "../style";
import { LogoIcon } from "../assets";
import { Reveal } from "./reveal";

const Services = () => {
  return(
    <div className={`${styles.flexCenter} py-20 w-full`}>
      <div className={`w-full justify-center items-start flex flex-col md:flex-row py-20 px-10 gap-10`}>  
        <Reveal className="flex flex-col gap-4 items-start md:items-end py-40 pb-16">
          <h2 className="text-sm font-semibold">
            Our Services
          </h2>
          <h2 className="pt-4 xs:text-md text-md font-semibold max-w-[300px]">
            Empowering
          </h2>
          <h2 className="xs:text-md text-md font-semibold max-w-[300px] text-secondary">
            Africa's Future
          </h2>
        </Reveal>
        
        <div className="flex flex-col gap-4 items-start">
          <Reveal>
            <div className={`pb-14 flex flex-col items-start`}>
              <p className={`xs:text-mm text-sm text-start my-2 max-w-[600px]`}>
                Consultancy packages shaped around your school’s needs.
              </p>
    
              <p className={`text-secondary xs:text-mm text-sm text-start my-6 max-w-[500px]`}>
                Aegis offers three levels of support depending on the school’s current context, priorities and readiness for change. Fees are shared following enquiry so that scope, staff numbers, location, travel requirements and level of support can be properly considered.
              </p>
    
              <span className="xs:mb-6 border-b border-2 border-second w-[100px]"></span> 
        
            </div>        
          </Reveal>
        </div>     
      </div>
    </div>
)};

export default Services;